import type { ReactNode } from "react";

import { HorizontalFlexbox } from "@src/shared/components/layout/Flexbox";
import { cn } from "@src/shared/lib/utils";

import type { AgendaConcernHeaderModel } from "../../../../domain";

export interface AgendaConcernHeaderProps {
  header: AgendaConcernHeaderModel;
  dragHandle?: ReactNode;
  className?: string;
}

export function AgendaConcernHeader({
  header,
  dragHandle,
  className,
}: AgendaConcernHeaderProps) {
  const hasCodes = header.shownCodes.length > 0 || header.overflowCount > 0;

  return (
    <HorizontalFlexbox
      alignItems="center"
      className={cn(
        "min-w-0 gap-2 py-0.5",
        dragHandle ? "relative" : null,
        className,
      )}
    >
      {dragHandle}
      <HorizontalFlexbox
        alignItems="baseline"
        className="min-w-0 flex-1 gap-1.5"
      >
        <h2 className="min-w-0 truncate text-[12.5px] font-semibold tracking-[-0.01em] text-surface-foreground">
          {header.title}
        </h2>
        {hasCodes ? (
          <HorizontalFlexbox alignItems="baseline" className="shrink-0 gap-1.5">
            {header.shownCodes.map((code) => (
              <span
                key={code.code}
                className="font-mono text-[10px] text-muted-foreground"
              >
                {code.code}
              </span>
            ))}
            {header.overflowCount > 0 ? (
              <span className="font-mono text-[10px] text-muted-foreground">
                +{header.overflowCount}
              </span>
            ) : null}
          </HorizontalFlexbox>
        ) : null}
      </HorizontalFlexbox>
    </HorizontalFlexbox>
  );
}
